import { callRest } from '@/common/utils/utils';
import { useEffect, useState } from 'react';

export const useMembershipEvents = (
  membershipId: number,
  onError?: () => void
) => {
  const [membershipEvents, setMembershipEvents] = useState([]);

  useEffect(() => {
    if (membershipId) {
      callRest(
        '/pos_customer/customer_membership_events/',
        { membership_id: membershipId },
        m => {
          setMembershipEvents(m?.data?.data || []);
        },
        () => {
          setMembershipEvents([]);
          onError?.();
        }
      );
    } else {
      setMembershipEvents([]);
    }
  }, [membershipId]);

  return membershipEvents;
};
